<!--
 * @Descripttion: 选择租户弹窗组件
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-09-19 15:25:27
 * @LastEditors: chenhongwei chenhw2019@gmail.com
 * @LastEditTime: 2023-06-09 17:20:36
-->
<template>
	<el-dialog
		title="请选择要进入的团队"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		width="540px"
		:show-close="showClose"
		append-to-body
	>
		<i class="el-icon-close fz-20 pos-abso cursor-pointer" style="right: 24px; top: 24px" v-if="showClose" @click="hide"></i>
		<h3 class="yx-color-text-primary fz-24 yx-pingfang-Medium mb-32 mt-32 flex-center">
			<img src="@/assets/public/select-group-title.png" alt="" style="width: 60px" class="mr-16" />
			请选择要进入的团队
		</h3>
		<div class="dialog-content" style="padding: 0 44px 32px 44px">
			<div
				class="group-item cursor-pointer"
				v-for="tenant in tenantInfoList"
				:key="tenant.tenantId"
				@mouseenter="changeHoverId(tenant.tenantId)"
				@mouseleave="changeHoverId('')"
			>
				<div class="flex-row-align-center">
					<yx-avatar class="mr-12" v-if="tenant.avatar" :src="tenant.avatare" :size="48"></yx-avatar>
					<span v-else class="group-icon flex-center font-h2-medium yx-color-primary mr-12">{{ getTenantFirstText(tenant.tenantName) }}</span>
					<span class="yx-color-text-primary font-h3-regular line-ellipsis-1">
						{{ tenant.tenantName }}
					</span>
				</div>
				<el-button type="primary" @click="chooseGroup(tenant)" :plain="hoverTenantId !== tenant.tenantId">进入团队</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
export default {
	components: {},
	props: {
		tenantInfoList: {
			type: Array,
			default: () => [],
		},
		showClose: {
			type: Boolean,
			default: true,
		},
		tenantId: {
			type: [String, Number],
		},
	},
	data() {
		return {
			dialogVisible: false,
			curTenantId: '',
			hoverTenantId: '',
		};
	},
	created() {
		this.curTenantId = this.tenantId;
	},
	watch: {
		tenantId(val) {
			this.curTenantId = val;
		},
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		hide() {
			this.dialogVisible = false;
		},
		changeHoverId(id) {
			this.hoverTenantId = id;
		},
		chooseGroup(tenant) {
			// 已选中团队不可点击
			if (tenant.tenantId === this.curTenantId) {
				return;
			}
			this.curTenantId = tenant.tenantId;
			this.$emit('choose', tenant);
		},
		getTenantFirstText(name) {
			return name.substring(0, 1);
		},
	},
};
</script>
<style lang="less" scoped>
.group-item {
	padding: 32px 24px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 1px solid #f4f1ff;
	border-radius: 8px;
	& + & {
		margin-top: 24px;
	}
	&:hover {
		border: 1px solid #bdd5ff;
		box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
	}
}
.dialog-content {
	max-height: 378px;
	min-height: 300px;
	overflow-y: auto;
}
/deep/.el-dialog__header {
	display: none;
}
/deep/.el-dialog {
	border-radius: 12px;
}
::-webkit-scrollbar {
	width: 6px;
}
&::-webkit-scrollbar-thumb {
	height: 26px;
	border-radius: 3px;
	background-color: @color-gy6;
}
.group-icon {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: fadeout(@color-primary, 85%);
}
</style>
